import { __assign } from 'tslib';
import { LOCATION_LITE_COOKIE_DATA_VERSION } from '../constants.esm.js';

var defaultCookieData = {
    countryCode: 'US',
    setBy: 'fallback',
    version: LOCATION_LITE_COOKIE_DATA_VERSION,
};
var getCookieWithDefaults = function (cookieData) {
    if (cookieData === void 0) { cookieData = {}; }
    return (__assign(__assign({}, defaultCookieData), cookieData));
};

export { getCookieWithDefaults };
//# sourceMappingURL=defaults.esm.js.map
